module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/email/email.html
// module id = 494
// module chunks = 0